module.exports = __webpack_public_path__ + "img/features-preview.b6678dc3.png";